"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPushPullApiImpl = void 0;
const tslib_1 = require("tslib");
const ApiBase_1 = require("@adaptabletools/adaptable/src/Api/Implementation/ApiBase");
const ModuleConstants = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Utilities/Constants/ModuleConstants"));
const IPushPullRedux = tslib_1.__importStar(require("./Redux/ActionReducers/IPushPullRedux"));
const ArrayExtensions_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/Utilities/Extensions/ArrayExtensions"));
const Helper_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/Utilities/Helpers/Helper"));
class IPushPullApiImpl extends ApiBase_1.ApiBase {
    constructor(adaptable, options) {
        super(adaptable);
        this.ippService = null;
        this.options = options;
    }
    getCurrentIPushPullUsername() {
        return this.getAdaptableState().System.CurrentIPushpullUsername;
    }
    getCurrentIPushPullPassword() {
        return this.getAdaptableState().System.CurrentIPushpullPassword;
    }
    getIPushPullUsername() {
        return this.options.username;
    }
    getIPushPullPassword() {
        return this.options.password;
    }
    getAutoLogin() {
        var _a;
        return (_a = this.options.autoLogin) !== null && _a !== void 0 ? _a : false;
    }
    getCurrentLiveIPushPullReport() {
        return this.getAdaptableState().System.CurrentLiveIPushPullReport;
    }
    setIPushPullInstance(ippInstance) {
        this.ippInstance = ippInstance;
    }
    getIPushPullInstance() {
        return this.ippInstance;
    }
    sendSnapshot(iPushPullReport) {
        if (this.checkItemExists(iPushPullReport, iPushPullReport.ReportName, 'IPushPull Report')) {
            this.dispatchAction(IPushPullRedux.IPushPullSendSnapshot(iPushPullReport));
            this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'SnapshotSent');
        }
    }
    startLiveData(iPushPullReport) {
        if (this.checkItemExists(iPushPullReport, iPushPullReport.ReportName, 'IPushPull Report')) {
            this.dispatchAction(IPushPullRedux.IPushPullLiveReportSet(iPushPullReport));
            this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'LiveDataStarted', iPushPullReport);
        }
    }
    stopLiveData() {
        let currentLiveReport = this.getCurrentLiveIPushPullReport();
        if (!currentLiveReport) {
            return;
        }
        this.getIPPService().unloadPage(currentLiveReport.Page);
        // clear the live report
        this.dispatchAction(IPushPullRedux.IPushPullLiveReportClear());
        // fire the Live Report event for Export Stopped
        this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'LiveDataStopped', currentLiveReport);
    }
    isIPushPullReportLive(iPushPullReport) {
        if (!iPushPullReport) {
            return false;
        }
        const CurrentLiveIPushPullReport = this.getCurrentLiveIPushPullReport();
        return CurrentLiveIPushPullReport != null && CurrentLiveIPushPullReport == iPushPullReport;
    }
    isIPushPullAvailable() {
        return true;
    }
    isIPushPullRunning() {
        return this.getAdaptableState().System.IsIPushPullRunning;
    }
    getIPushPullDomains() {
        return this.getAdaptableState().System.IPushPullDomainsPages || [];
    }
    getPagesForIPushPullDomain(folderName) {
        let returnArray = [];
        let iPushPullDomains = this.getIPushPullDomains();
        if (ArrayExtensions_1.default.IsNotNullOrEmpty(iPushPullDomains)) {
            let iPushPullDomain = iPushPullDomains.find((f) => f.Name == folderName);
            if (iPushPullDomain) {
                returnArray = iPushPullDomain.Pages;
            }
        }
        return returnArray;
    }
    setIPushPullLoginErrorMessage(loginErrorMessage) {
        this.dispatchAction(IPushPullRedux.IPushPullSetLoginErrorMessage(loginErrorMessage));
    }
    getFolderIdForName(folderName) {
        let iPushPullDomains = this.getIPushPullDomains();
        return iPushPullDomains.find((i) => i.Name == folderName).FolderId;
    }
    addNewIPushPullPage(folderName, pageName) {
        let folderId = this.getFolderIdForName(folderName);
        this.getIPPService().addNewPage(folderId, pageName);
    }
    getIPushPullThrottleTime() {
        return this.options.throttleTime;
    }
    setIPushPullThrottleTime(throttleTime) {
        this.dispatchAction(IPushPullRedux.IPushPullSetThrottleTime(throttleTime));
    }
    setIPushPullDomains(iPushPullDomains) {
        this.dispatchAction(IPushPullRedux.IPushPullSetDomainsPages(iPushPullDomains));
    }
    clearIPushPullDomains() {
        this.dispatchAction(IPushPullRedux.IPushPullClearDomainsPages());
    }
    getIPushPullSchedules() {
        return this.getAdaptableState().Schedule.IPushPullSchedules || [];
    }
    showIPushPullPopup() {
        this.showModulePopup(ModuleConstants.IPushPullModuleId);
    }
    setIPushPullAvailableOn() {
        this.dispatchAction(IPushPullRedux.SetIPushPullAvailableOn());
    }
    setIPushPullAvailableOff() {
        this.dispatchAction(IPushPullRedux.SetIPushPullAvailableOff());
    }
    setIPushPullRunningOn() {
        this.dispatchAction(IPushPullRedux.SetIPushPullRunningOn());
        this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'Connected');
    }
    setIPushPullRunningOff() {
        this.dispatchAction(IPushPullRedux.SetIPushPullRunningOff());
        this.adaptable.ReportService.PublishLiveLiveDataChangedEvent('ipushpull', 'Disconnected');
    }
    isIPushPullLiveDataRunning() {
        return Helper_1.default.objectExists(this.getCurrentLiveIPushPullReport());
    }
    getIPPService() {
        if (!this.ippService) {
            this.ippService = this.adaptable.getPluginProperty('ipushpull', 'service') || null;
        }
        return this.ippService;
    }
    async loginToIPushPull(userName, password) {
        await this.getIPPService().login(userName, password);
        const domainpages = await this.getIPPService().getDomainPages();
        this.setIPushPullDomains(domainpages);
        this.setIPushPullRunningOn();
        this.getAdaptableApi().internalApi.hidePopupScreen();
        this.setIPushPullLoginErrorMessage('');
        this.dispatchAction(IPushPullRedux.IPushPullSetLoginDetails(userName, password));
    }
    async retrieveIPushPullDomainsFromIPushPull() {
        this.clearIPushPullDomains();
        const domainpages = await this.getIPPService().getDomainPages();
        this.setIPushPullDomains(domainpages);
    }
    logoutFromIPushPull() {
        this.clearIPushPullInternalState();
        this.dispatchAction(IPushPullRedux.IPushPullLogout());
        this.getAdaptableApi().internalApi.hidePopupScreen();
    }
    includeSystemReports() {
        return this.options.includeSystemReports || false;
    }
    clearIPushPullInternalState() {
        this.setIPushPullDomains([]);
        this.setIPushPullRunningOff();
        this.setIPushPullLoginErrorMessage('');
        this.dispatchAction(IPushPullRedux.IPushPullLiveReportClear());
    }
}
exports.IPushPullApiImpl = IPushPullApiImpl;
